<template>
  <div>
    <!-- @click="handleSubmit" -->
    <button  id="sendCodePrivacy" type="button" class="btn" :class="{'is-default': type==='btn', 'is-mini': type==='btn-mini', 'is-fixed': type==='fixed','is-text':
    type==='text',
    'is-info': type==='info', 'theme-white': theme==='white'}">
      <img class="privacy-icon" :src="iconUrl" />
    </button>
    <common-confirm v-model="isVerificationCodeLayer"
                    :is-button="false"
                    title="安全验证"
                    width="90%">
      <div slot="content">
        <div class="verification-code" id="captcha"></div>
      </div>
    </common-confirm>
  </div>
</template>

<script>
const CommonConfirm = () => import("@/components/Common/CommonConfirm");
import api from '@/api'

export default {
  name: "PrivacyButton",
  props: {
    type: {
      type: String,
      default: 'btn'
    },
    theme: {
      type: String,
      default: 'default'
    },
    refresh: null
  },
  data() {
    return {
      token: "",
      isShow: false,
      iconUrl: require("@/assets/icon-visible.png"),
      icons: [{
        url: require("@/assets/icon-invisible.png")
      },{
        url: require("@/assets/icon-visible.png")
      }],
      iconsWhite: [{
        url: require("@/assets/icon-invisible-white.png")
      },{
        url: require("@/assets/icon-visible-white.png")
      }],
      isAllowNvc: true,
      isVerificationCodeLayer: false,
      captcha:null
    }
  },
  components: {
    CommonConfirm
  },
  watch: {
    isShow(val) {
      this.getIcon(val);
    },
    refresh() {
      this.getPrivacyProtectionStatus();
    }
  },
  created() {
    this.token = this.$store.state.user.userToken;
    this.getPrivacyProtectionStatus();
  },
  beforeMount() {
    this.initAWSC();
  },
  methods: {
    async handleSubmit () {
      if (!this.isAllowNvc) {
        return;
      }

      // 人机验证
      if (!window.nvc) return;
      this.$loading.show();
      window.nvc.getNVCValAsync(async (nvcVal) => {
        // 无痕验证获取nvc data，用无痕验证模式调是否用开启隐私保护接口
        const request = this.getRequest("AliYunAfsNvc", nvcVal);
        await this.updatePrivacyStatus(request);
      });
    },
    async getPrivacyProtectionStatus () {
      const { success, data, errMsg } = await api.user.changePrivacyProtectionIsOpen(this.token)
      if(success) {
        this.isShow = data;
        this.$store.commit("SET_IS_MASK_VALUE", data);
      } else {
        this.$alert.show(errMsg)
      }
    },
    getIcon(val) {
      let icons = this.theme === 'default' ? this.icons : this.iconsWhite;
      this.iconUrl = val ? icons[0].url : icons[1].url;
    },
    getInstance(instance) {
      this.captcha = instance
    },
    fail(error) {
      console.error(error);
      this.isAllowNvc = false
    },
    async success(captchaVerifyParam) {
      console.log(captchaVerifyParam,'captchaVerifyParam');
      this.isAllowNvc = true
      this.isVerificationCodeLayer = false;
      this.$loading.show();
      const request = this.getRequest("AliYunAfsNc", captchaVerifyParam);
      await this.updatePrivacyStatus(request);
    },
    initAWSC () {
      this.getIcon(this.isShow);
      if (!window.initAliyunCaptcha) return
      // window.AWSC.use("nvc", (state, module) => {
      //   // 初始化 调用module.init进行初始化
      //   window.nvc = module.init({
      //     appkey: "FFFF0N00000000009D85",
      //     scene: "nvc_message",
      //     renderTo:'#captcha',
      //     // test: module.TEST_NC_PASS,
      //     // 二次验证获取人机信息串，跟随业务请求一起上传至业务服务器，由业务服务器进行验签。
      //     success: async (data) => {
      //       this.isVerificationCodeLayer = false;
      //       this.$loading.show();
      //       const request = this.getRequest("AliYunAfsNc", data);
      //       await this.updatePrivacyStatus(request);
      //     },
      //     // 前端二次验证失败时触发该回调参数
      //     fail: (failCode) => {
      //       window.console && console.log(failCode);
      //       this.isAllowNvc = false;
      //     },
      //     // 前端二次验证加载异常时触发该回调参数。
      //     error: (errorCode) => {
      //       window.console && console.log(errorCode);
      //       this.isAllowNvc = false;
      //     }
      //   });
      // });


       window.initAliyunCaptcha({
    // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      SceneId: "5v4v21th",
      // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
      mode: "popup",
      // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      element: "#captcha",
      // 触发验证码弹窗或无痕验证的元素
      button: "#sendCodePrivacy",
      // 验证码验证通过回调函数
      success: this.success,
      // 验证码验证不通过回调函数
      fail: this.fail,
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: this.getInstance,
      // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
      slideStyle: {
        width: 260,
        height: 40,
      },
      // ...其他参数，参考initAliyunCaptcha参数说明
    });

    },
    async updatePrivacyStatus(request) {
      if (!this.isAllowNvc) return;
      const { success, errMsg } = await api.user.updateUserPrivacyProtection(request);
      this.$loading.hide();
      if (!success) {
        console.error(errMsg);
        if (errMsg === 'NvcNc' || errMsg === 'Block') {
          // this.afsFailureHandler(errMsg)
        } else {
          this.$alert.show(errMsg);
          this.initAWSC()
        }
      } else {
        this.isShow = request.isOpenPrivacyProtection;
        this.$store.commit("SET_IS_MASK_VALUE", this.isShow);
        this.$emit("privacy-switch", true);
        this.initAWSC()
      }
    },
    // 无痕验证模式发送短信失败处理方法
    afsFailureHandler(code) {
      console.log('afsFailureHandler'+code)
      this.isVerificationCodeLayer = true;
      // 行为可疑，进入二次滑动验证
      if (code === 'NvcNc') {
        const ncoption = {
          renderTo: "#captcha",
        }
        let childNodes = document.getElementById('captcha').childNodes;
        for (let i = 0; i < childNodes.length; i++) {
          let childNode = childNodes[i];
          childNode.parentElement.removeChild(childNode);
        }
        // 唤醒二次验证（滑动验证码）
        window.nvc.getNC(ncoption);
      } else if (code === 'Block') {
        // 返回block，禁止提交
        this.isAllowNvc = false
        this.$alert.show(
            "网络错误，请刷新页面重试。"
        );
      }
    },
    getRequest (codeType, codeValue) {
      return {
        userName: this.token,
        isOpenPrivacyProtection: !this.isShow,
        sessionKey: this.sessionKey,
        codeType: codeType,
				codeValue: codeValue,
        sceneId: '5v4v21th',
				captchaVerifyParam: codeValue,
      };
    }
  }
}
</script>

<style scoped lang="less">
.btn {
  height: 1.6rem;
  width: 1.6rem;
  border: none;
  border-radius: 0;
  font-size: 12px;
  position: relative;
  &:focus {
    outline: none;
  }
  &.theme-white {
    color: #FFFFFF;
  }
  & .privacy-icon {
    height: 1rem;
    width: 1rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  &.is-default {
    background-color: #FFFFFF;
    border: 1px solid #cccccc;
    & .privacy-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }

  &.is-mini {
    height: 1.2rem;
    padding: 0 0.25rem 0 0.25rem;
    background-color: #FFFFFF;
    border: 1px solid #cccccc;
    & .privacy-icon {
      height: 0.8rem;
      width: 0.8rem;
    }
  }

  &.is-fixed {
    height: 2.4rem;
    width: 2.4rem;
    border-radius: 2.4rem;
    background-color: #FFFFFF;
    border: 1px solid #cccccc;
    box-shadow: 0 0 10px rgba(0,0,0,.2);
    padding: 0.25rem;
    position: fixed;
    top: 5.2rem;
    right: 10px;
    z-index: 10500;
    & > span {
      display: block;
      margin: -0.2rem auto 0;
    }
    & .privacy-icon {
      display: block;
    }
  }

  &.is-text {
    height: 50px;
    background-color: transparent;
    border: none;
    & > span {
      display: block;
      margin: -0.2rem auto 0;
      height: 1rem;
      line-height: 1rem;
      font-size: 10px;
      background-color: transparent;
    }
    & .privacy-icon {
      display: block;
      height: 1.1rem;
      width: 1.1rem;
      margin: 0 auto;
    }
  }

  &.is-info {
    height: 25px;
    background-color: #FFFFFF;
    border: 1px solid #cccccc;
    & > span {
      display: block;
      margin: -0.2rem auto 0;
    }
    & .privacy-icon {
      display: block;
    }
  }
}

#captcha {
  position: relative;
  width: 300px;
  margin: 15px auto;
  .nc_wrapper {
    width: 100%;
  }
}
.title {
  margin: 10px auto 0;
  text-align: center;
}
</style>